import './ViewMedicalRecordScreen.scss';
import CardComponent from "../../../shared/components/card/CardComponent";
import ChipComponent from "../../../shared/components/chip/ChipComponent";
import {ImageConfig} from "../../../constants";
import moment from "moment-timezone";
import {CommonService} from "../../../shared/services";
import MedicalRecordSharedDocument from "../medical-record-shared-document/MedicalRecordSharedDocument";

interface IViewMedicalRecordScreenProps {
    medicalRecordData: any;
}

const ViewMedicalRecordScreen = (props: IViewMedicalRecordScreenProps) => {
    const {medicalRecordData} = props;

    return (
        <div className="view-medical-record-screen">
            <CardComponent className={'mrg-top-25'}>
                <div className={'medical-record-card-header'}>
                    <div className={'case-details-heading'}>Case Details</div>
                    <ChipComponent label={medicalRecordData?.status}
                                   className={medicalRecordData?.status === 'open' ? 'open' : 'closed'}/>
                </div>
                <div className={'medical-record-card-body'}>
                    <div className={'medical-record-card-body-upper-item'}>
                        <div className={'container'}>
                            <div className={'icon-wrapper'}>
                                <ImageConfig.Calendar3Icon height={30} width={30}/>
                            </div>
                            <div className={'details-wrapper'}>
                                <div>Date of Onset</div>
                                <div
                                    className={'mrg-top-5'}>
                                    <b>{moment(medicalRecordData?.onset_date).format('DD-MMM-YYYY')}</b></div>

                            </div>
                        </div>

                        <div className={'container  justify-content-center'}>
                            <div className={'icon-wrapper'}>
                                <ImageConfig.Calendar3Icon height={30} width={30}/>
                            </div>
                            <div className={'details-wrapper'}>
                                <div>Date of Surgery</div>
                                <div
                                    className={'mrg-top-5'}>
                                    <b>{medicalRecordData?.surgery_date ? moment(medicalRecordData?.surgery_date).format('DD-MMM-YYYY') : 'N/A'}</b>
                                </div>

                            </div>
                        </div>
                        <div className={'container justify-content-center'}>
                            <div className={'icon-wrapper'}>
                                <ImageConfig.PersonIcon height={30} width={30}/>
                            </div>
                            <div className={'details-wrapper'}>
                                <div>Case Physician</div>
                                <div
                                    className={'mrg-top-5'}>
                                    <b>{medicalRecordData?.case_physician?.name ? medicalRecordData?.case_physician?.name : 'N/A'}</b>
                                </div>

                            </div>
                        </div>
                        <div className={'container last-container  justify-content-center '}>
                            <div className={'icon-wrapper'}>
                                <ImageConfig.HashIcon height={30} width={30}/>
                            </div>
                            <div className={'details-wrapper'}>
                                <div>Appointments Completed</div>
                                <div className={'mrg-top-5'}>
                                    <b>{medicalRecordData?.appointments_count > 0 ? medicalRecordData?.appointments_count + ' appointments' : 'N/A'}</b>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={'description-wrapper'}>
                        <div className={'icon-wrapper'}>
                            <ImageConfig.DocumentIcon height={30} width={30}/>
                        </div>
                        <div>
                            <div className={'description-heading'}>Description</div>
                            <div className={'description-body'}>
                                <b> {medicalRecordData?.category_details?.name} - {medicalRecordData?.service_details?.name}</b>
                            </div>
                        </div>
                    </div>
                    <div className={'description-wrapper'}>
                        <div className={'icon-wrapper'}>
                            <ImageConfig.DocumentClipIcon height={30} width={30}/>
                        </div>
                        <div>
                            <div className={'description-heading'}>Case Name</div>
                            <div className={'description-body'}>
                                <b>{CommonService.getDateFromTimezone(medicalRecordData?.created_at, moment.tz.guess(), 'DD-MMM-YYYY')}

                                    {medicalRecordData?.injury_details?.map((injury: any, index: number) => {
                                        return <>{" "}{injury?.body_part_name} {injury?.body_side ? `(${injury?.body_side})` : ''}{index !== medicalRecordData?.injury_details?.length - 1 ? <>,</> : ''}</>;
                                    })}
                                </b>
                            </div>
                        </div>
                    </div>
                    <div className={'icd-codes-wrapper'}>
                        <div className={'icon-wrapper'}>
                            <ImageConfig.Document2Icon height={30} width={30}/>
                        </div>
                        <div className={'description-heading'}>Medical Diagnosis/ICD Codes:</div>

                    </div>
                    <div className={'icd-table-wrapper mrg-bottom-25 mrg-left-30'}>
                        <div className="icd-table-container">
                            <div className="icd-table">
                                <div className="icd-header">
                                    <div className="icd-header-cell">ICD Code</div>
                                    <div className="icd-header-cell">Description</div>
                                </div>
                                <div className="icd-body">
                                    {medicalRecordData?.icd_codes?.length > 0 ? medicalRecordData?.icd_codes?.map((row: any, index: number) => (
                                        <div className="icd-row" key={index}>
                                            <div className="icd-cell">{row?.icd_code}</div>
                                            <div
                                                className={`icd-cell`}>
                                                {row.description}
                                            </div>
                                        </div>
                                    )) : <div className={'empty-data-text'}>
                                        No codes have been added.
                                    </div>}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </CardComponent>

            <div className={'mrg-top-25'}>
                <MedicalRecordSharedDocument caseId={medicalRecordData?._id}/>
            </div>

        </div>
    )
}
export default ViewMedicalRecordScreen;
